export const map = {
  apiKey: 'AIzaSyASPGLfb_wM5f0Tqk-hmda9PLcI_jPzWIc',
}
